import React,{Component} from 'react';
import PbAjax from '../../lib/pbajax';
import Cache from 'c-cache';
import publicpb from '../../base/public.pb';
import lang from '../../lang';
import Item from './host-item';
import Follow from "../../component/follow";
import Loading from '../../component/loading';
import PreventParentScroll  from '../../lib/scroll/prevent-scroll';
import listpb from './history.pb';
import { Link } from "react-router";
let cache = new Cache({
    prefix: 'pcuplive'
});

class List extends Component {
    static defaultProps = {
        threshold: 100,
        keyword: ''
    }
    constructor(props) {
        super(props);

        this.state = {
            //keyword: props.keyword,
            list: [],
            isEmpty: false,
            isLoading: true,
            isEnd: false
        };

        this.page = 0;
        this.pageSize = 6;
        this.pbajax = new PbAjax();

        this.fetching = false; // 加载状态加锁
        this.first = true; // 第一页
        this.dataOver = false // 数据最后一页
    }

    componentWillMount(){
        this.loadDataByUserName();
    }

    componentWillUnmount() {
        this.pbajax.cancel(); 
    }

    loadDataByUserName(){
        if(this.fetching ){
            return false;
        }
        this.fetching = true;

        let { Request, Response } = listpb.Room.NormalIntoHistory;
        let defer = $.Deferred();
        let businessData = new Request({
            page: this.page,
            pageSize: this.pageSize
        });

        this.pbajax.do({
                service: 'room',
                api: '/room/normal/into/history',
                header: {
                    userToken: UP.Global.getUserToken(),
                    'Accept-Language': UP.Global.siteLanguage
                }
            },
            businessData,
            (res) => {

            let dataWrap = publicpb.Result.decode(res);

            if (dataWrap.code == 1) {
                this.fetching = false;
                let dataAll, data = [];

                if (dataWrap.data.value) {
                    dataAll = Response.decode(dataWrap.data.value);
                    data = dataAll.intoHistoryInfos;
                }

                let list  = this.state.list;

                let newState = {
                    list: [...list, ...data]
                };

                // 数据加载完
                this.dataOver = true;
                newState.isLoading = false;

                if (this.first) {
                    if (data.length == 0) {
                        newState.isEmpty = true;
                    }
                } else {
                    newState.isEnd = true;
                }
                if (this.first) {
                    // 第一页
                    this.first = false;
                }

                this.setState(Object.assign({}, this.state, newState));
            } else {
                this.setState({
                    isLoading: false
                });
            }
          
        }, () => {
                this.fetching = false;
                this.setState({
                    isLoading: false
                });
            }
        );
    }

    onClick() {
        $.channel.emit('hideSearchResult');
    }

    render() {
        let list = this.state.list;
        let $list = [];
        let showList = ['username','gender', 'grade', 'signature'];

        list.slice(0,5).forEach((obj, idx)=>{

            $list.push((
                <Item key={obj.roomUid} item={obj} onClick={this.onClick} showList={showList}></Item>
            ));
        });

        if (list.length > 5) {
            $list[$list.length] = (
                <div className="more" key={$list.length + 1}>
                    <Link to='/history'>{lang.template('查看更多')}</Link>
                </div>
            );
        }

        return (
            <div ref="content">
                <PreventParentScroll/>
                <ul>
                    { $list }
                </ul>
                { this.state.isLoading ? <Loading/> : null }
                { this.state.isEmpty ? <li className="list-tip">{lang.template('没有浏览记录？')}</li> : null }
            </div>
        );
    }

};

export default List;



// WEBPACK FOOTER //
// ./js/header/history/list-pannel.js